import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { SettingsBillingContainer } from "@/components/features/settings/billing/ui/island";

import { useConfirmParams } from "./hooks";

export const SettingsBillingPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="料金プランの設定" url={generatePath(PATHS.SETTINGS.BILLING, { hotelID })}>
			<SettingsBillingContainer hotelID={hotelID} />
		</PageMeta>
	);
};

SettingsBillingPage.displayName = "SettingsBillingPage";
